import React from "react";
import styled from "styled-components/macro";
import { ReactComponent as LoadingImg } from "../../../assets/image/loader-2.svg";
import { css } from "styled-components/macro";
import { Link } from "react-router-dom";
const RegisterWrapper = styled.div`
  background: #eff4f6;
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
  align-content: space-evenly;
  & > div {
    -webkit-flex: 0 0 100%;
    flex: 0 0 100%;
    text-align: center;
  }
`;
const LoginInputWrapper = styled.div`
  position: relative;
  margin: 0 auto 12px;
  width: 70%;
  min-width: 200px;
  max-width: 400px;
  &.phoneInputWrapper input {
    padding: 0 5px 0 35px;
    text-align: left;
    font-size: 1.3rem;
    font-family: var(--fontNumber);
    letter-spacing: 5px;
    direction: ltr;
  }
  &.phoneInputWrapper span {
    position: absolute;
    left: 1px;
    line-height: 55px;
    top: 1px;
    bottom: 1px;
    width: 35px;
    text-align: center;
    font-size: 1.3rem;
    border-radius: 5px;
    font-family: var(--fontNumber);
    letter-spacing: 3px;
  }
  &.sign-in {
    width: 85%;
    display: flex;
    flex-wrap: wrap;
  }
`;
const LoginInput = styled.input`
  border: 1px solid var(--color1);
  width: 100%;
  padding: 0 40px 0 5px;
  height: 50px;
  border-radius: 8px;
  -webkit-transition: 0.3s ease border;
  transition: 0.3s ease border;
  ${LoginInputWrapper}.sign-in & {
    padding: 0 8px;
  }
`;
const VerifyInput = styled.input`
  flex: 0 0 15%;
  max-width: 15%;
  border: var(--color1) solid;
  border-width: 0 0 3px;
  height: 50px;
  background: transparent;
  text-align: center;
  font-size: 1.5rem;
  font-family: var(--fontNumber);
  direction: rtl;
  transition: 0.3s;
  &:focus {
    border-color: #9a2244;
  }
`;
const BgButton = styled.button`
  display: inline-block;
  margin: 0 auto;
  width: 150px;
  height: 35px;
  color: #fff;
  border: unset;
  background: var(--color2);
  border-radius: 5px;
  margin-bottom: 13px;
  font-size: 1.1rem;
  box-shadow: 0 0 3px var(--color2);
  transition: 0.2s;
  &:disabled,
  &.deactive {
    opacity: 0.5;
    box-shadow: 0 0 0 0 transparent;
  }
`;
const SBtn = styled.button`
  display: inline-block;
  text-align: center;
  font-size: 20px;
  border-radius: 7px;
  width: 70%;
  min-width: 200px;
  max-width: 400px;
  height: 55px;
  background: transparent;
  padding: 0 10px;
  color: var(--color2);
  border: 2px solid var(--color2);
  letter-spacing: 1px;
  position: relative;
  transition: 0.2;
  &:disabled {
    opacity: 0.5;
  }
`;
function SubmitBtn({ loading = false, children, ...props }) {
  return (
    <SBtn disabled={loading} {...props}>
      {loading ? (
        <LoadingImg
          css={css`
            height: 100px;
            position: absolute;
            top: -30px;
            left: 0;
          `}
        ></LoadingImg>
      ) : (
        children
      )}
    </SBtn>
  );
}
const InputIcon = styled.i`
  position: absolute;
  font-size: 2rem !important;
  line-height: 55px !important;
  text-align: center;
  width: 40px;
  color: var(--color1);
  right: 0;
`;
const ForgetLink = styled(Link)`
  font-size: 1.2rem;
  color: var(--color2);
  display: inline-block;
  line-height: 30px;
`;
export {
  RegisterWrapper,
  LoginInputWrapper,
  LoginInput,
  VerifyInput,
  BgButton,
  SubmitBtn,
  InputIcon,
  ForgetLink
};
